export default __webpack_public_path__ + "static/media/Group-923.144340bd.svg";